import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AlternativeStepperComponent,
  IStep,
} from '../../../../../components/ui/alternative-stepper/alternative-stepper.component';
import { SegmentInformationComponent } from '../../../../../components/organization/segments/segment-information/segment-information.component';
import { SegmentRuleComponent } from '../../../../../components/organization/segments/segment-rule/segment-rule.component';
import { SegmentReviewComponent } from '../../../../../components/organization/segments/segment-review/segment-review.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SegmentService } from '../../../../../services/segments/segment-service.service';
import { BackButtonComponent } from '../../../../../components/ui/back-button/back-button.component';
import { GroupAudienceService } from '../../../../../services/segments/group-audience.service';
import { SEGMENT_STEPS, SEGMENT_STEP_COPY } from '../create-segment/create-segment.component';

@Component({
  selector: 'app-edit-segment',
  standalone: true,
  imports: [
    AlternativeStepperComponent,
    SegmentInformationComponent,
    SegmentRuleComponent,
    SegmentReviewComponent,
    BackButtonComponent,
  ],
  templateUrl: './edit-segment.component.html',
  styleUrls: ['../create-segment/create-segment.component.css', './edit-segment.component.css'],
})
export class EditSegmentComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);
  private audience = inject(GroupAudienceService);
  segmentService = inject(SegmentService);
  router = inject(Router);
  searchQuery!: string;

  steps: IStep[] = SEGMENT_STEPS;

  /** True once the builder holds the saved segment named in the URL. */
  ready = false;
  loadError = '';

  get routeParamId() {
    return this.route.snapshot.paramMap.get('id');
  }

  get description(): string {
    return SEGMENT_STEP_COPY[this.searchQuery] ?? SEGMENT_STEP_COPY['information'];
  }

  get segmentName(): string {
    return this.segmentService.segmentInformation.segmentName;
  }

  backToSegments() {
    this.segmentService.clearSegmentInformation();
    this.router.navigate(['organization', 'contacts', 'segmented-list']);
  }

  /** Reads the segment from the server when the builder does not hold it (a refresh or a shared link). */
  loadSegment() {
    const id = this.routeParamId;
    if (!id) {
      this.loadError = 'This link does not name a segment.';
      return;
    }
    this.loadError = '';
    this.audience
      .getSegment(id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (segment) => {
          this.segmentService.startEditing(segment);
          this.ready = true;
        },
        error: () => {
          this.loadError = 'This segment did not load. It may have been deleted, or the connection dropped.';
        },
      });
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.searchQuery = params['title'];
    });

    if (this.segmentService.isEditing(this.routeParamId)) {
      this.ready = true;
    } else {
      this.loadSegment();
    }
  }
}
